import type { ReactNode } from "react";

import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface EmptyStateProps {
  /** Already-translated empty message. */
  children: ReactNode;
  /** Optional CTA (e.g. an "Add X" button), centered under the message. */
  action?: ReactNode;
  className?: string;
}

// The canonical empty state (DESIGN.md › Tables): a separate Card with muted,
// centered text — never an empty table body row.
export function EmptyState({ children, action, className }: EmptyStateProps) {
  return (
    <Card className={cn("p-8 text-center", className)}>
      <p className="text-muted-foreground">{children}</p>
      {action && <div className="mt-4 flex justify-center">{action}</div>}
    </Card>
  );
}
